import { Arrow } from '@studio/design-system/tooltip';
import type { ReactElement } from 'react';
import { Icon } from '@studio/design-system/icon';
import { Tooltip } from '@studio/design-system/tooltip';
import { motion } from 'framer-motion';

/** Camera model tooltip properties. */
export type CameraModelTooltipProps = {
  zIndex?: number;
};

/** Camera model tooltip content component. */
export const CameraModelTooltip = ({ zIndex }: CameraModelTooltipProps): ReactElement => {
  return (
    <Tooltip
      zIndex={zIndex ?? 300}
      trigger={
        <button
          type='button'
          className='hover:cursor-pointer'
          aria-label='Learn about driver stability levels'
        >
          <Icon className='text-sm text-muted hover:text-foreground' icon='info' />
        </button>
      }
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.2 }}
      >
        <div className='max-w-[320px] rounded-4 bg-[white] px-16 py-12 text-sm text-black shadow-lg'>
          <div className='space-y-8'>
            <div>
              <div className='text-gray-600 text-sm leading-[14px]'>
                <span className='font-bold'>Beta:</span> This Driver is still under testing and may
                have limited functionality.
              </div>
            </div>
          </div>
          <Arrow className='fill-[white]' />
        </div>
      </motion.div>
    </Tooltip>
  );
};
